
import { Component, Vue, Prop } from 'vue-property-decorator';

import ExpandIcon from "@/components/utils/ExpandIcon.vue";
import { GetInstructionFile } from '@/components/utils/GetInstructionFile';


@Component({
    components:{
        ExpandIcon
    }
})
export default class TheHearingAppRightToAppealPg extends Vue { 

    @Prop({required: true})
    app!: boolean;
    
    showPrepareHearingInfo = true;
    showPointsInfo = false;
    showOrderInfo = false;
    showDirectionsInfo = false;

    public showPrepareHearing(show: boolean){
        if (show) {
            this.showPrepareHearingInfo = true;
            this.$emit('adjustHeights', 0, "5rem")
        } else {
            this.showPrepareHearingInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    }

    public showPoints(show: boolean){
        const pointsLength = this.app?'33rem':'35rem';
        if (show) {
            this.showPointsInfo = true;
            this.$emit('adjustHeights', 1, pointsLength)
        } else {
            this.showPointsInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }

    public showOrder(show: boolean){
        if (show) {
            this.showOrderInfo = true;
            this.$emit('adjustHeights', 1, "7rem")
        } else {
            this.showOrderInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }

    public showDirections(show: boolean){
        if (show) {
            this.showDirectionsInfo = true;
            this.$emit('adjustHeights', 3, "14rem")
        } else {
            this.showDirectionsInfo = false;
            this.$emit('adjustHeights', 3, "0");
        }
    }

    public showOrdersSection(){
        
        this.$emit('showOrders');
    }

    public downloadInstructions(pdf_name){

        GetInstructionFile(pdf_name);
        
    }

}
